module.exports = __webpack_public_path__ + "static/media/view3.8379817c.jpg";